import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import React, { memo, useState } from 'react';

import { neutral } from '../../../styles/mui/colors';

const style = {
  borderRadius: 200,
  bgcolor: 'white',
  borderColor: neutral[200],
  '&:hover': {
    bgcolor: 'white',
  },
  '&:active': {
    bgcolor: 'white',
  },
  '&:focus': {
    bgcolor: 'white',
  },
  '& .MuiButton-startIcon': {
    color: 'inherit',
  },
  color: 'inherit',
};

const SelectSingleFilterPopupComponent = ({ initialValues, queryParamNames, label, onSelect }) => {
  const getQueryParamName = (queryParamNames) => {
    return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
  };

  const queryParamName = getQueryParamName(queryParamNames);
  const initialValue = initialValues && initialValues[queryParamName];
  const [isChecked, setIsChecked] = useState(!!initialValue);

  const toggleCheckbox = () => {
    const newCheckedStatus = !isChecked;
    setIsChecked(newCheckedStatus);
    onSelect({ [queryParamName]: newCheckedStatus ? '1' : null });
  };

  return (
    <Button onClick={toggleCheckbox} sx={style} variant="outlined">
      <Typography component="h3" variant="body2">
        {label}
      </Typography>
      <Checkbox checked={isChecked} color="primary" sx={{ p: 0, pl: 2 }} />
    </Button>
  );
};

SelectSingleFilterPopupComponent.displayName = 'SelectSingleFilterPopup';
const SelectSingleFilterPopup = memo(SelectSingleFilterPopupComponent);
export default SelectSingleFilterPopup;
